import { PAYMENT_REQUIRED } from "@reduxLocal/actions/types";
import { store } from "@reduxLocal/persistState";
import { userDataIndicatesPaidSubscription } from '@utils/subscriptionBillingGuard';
import notifee, { EventType } from '@notifee/react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from "react-native";
import { scheduleNotification } from "./notifications/noticeScheduler";

const CACHE_KEY = "lastPaymentNotificationTime";
const NOTIFICATION_INTERVAL = 30 * 60 * 1000; // 30 minutes in milliseconds

async function canSendNotification() {
  const lastNotified = await AsyncStorage.getItem(CACHE_KEY);
  const now = Date.now();

  if (!lastNotified || now - parseInt(lastNotified, 10) > NOTIFICATION_INTERVAL) {
    await AsyncStorage.setItem(CACHE_KEY, now.toString()); // Update cache
    return true;
  }
  return false;
}

export async function showPaymentExpiredNotification(message: string) {
	// if (!(await canSendNotification())) return; // Skip notification if within 30 min
	const channelId = await notifee.createChannel({
		id: 'billing',
		name: 'Billing',
	});

	if (Platform.OS === 'android') {
		await notifee.displayNotification({
			id: 'payment-expired',
			title: 'Reached usage limit',
			body:
				message ||
				'You have reached your usage limit. Please upgrade to a paid plan to make more.',
			android: {
				channelId,
				importance: notifee.AndroidImportance.HIGH,
			},
		});
	} else {
		await notifee.displayNotification({
			id: 'payment-expired',
			title: 'Reached usage limit',
			body:
				message ||
				'You have reached your usage limit. Please upgrade to a paid plan to make more.',
		});
	}
}

  export default async function paymentDispatcher(path: string, level?: string, message?: string) {
    const state = store.getState();
    const userData = state.promiseData?.data?.userData;
    const companyId = state.app?.selectedProfile?.id;
    // In company context, personal paid status must not suppress warnings —
    // companies are always paid and may still need billing.
    if (!companyId && userDataIndicatesPaidSubscription(userData)) {
      return;
    }
    //Check notifee permission
    store.dispatch({
		type: PAYMENT_REQUIRED,
		payload: {
			_id: 'billing-warning',
			title: `Reached usage limit for ${path}`,
			body:
				message ||
				`You have reached your usage limit for ${path}. Please upgrade to a paid plan to make more.`,
			stack: 'Settings',
			screen: 'Upgrade',
			timestamp: Date.now(),
			type: level || 'warning',
		},
	});
		const now = new Date();
		const scheduledTime = new Date();
		scheduledTime.setHours(19, 0, 0, 0); // Set time to 7:00 PM

		// If the current time is past 7 PM, schedule for the next day
		if (now > scheduledTime) {
			scheduledTime.setDate(scheduledTime.getDate() + 1);
		}

		await scheduleNotification(
			"payment-issue",
			"Your plan has expired but don't let that stop you!",
			message,
			scheduledTime
		);
}
